import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../../common_components/common_widgets/toast/notify";

export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';

export const service = async (data) => {
    const response: any = await callMdaePublicApi({
        type: 'post',
        contentType: 'application/json',
        url: '/Api/Document/DeleteDocument',
        isRoutedApiCall: true,
        ...getDefaultOptions(),
        body:Array.isArray(data) ? JSON.stringify({DocumentsToDelete: data}) : JSON.stringify({...data})
    })
    throwExceptionErrors(response);
    if(data && data.length > 1){ 
        mdaeNotfy({ message:  data.length + " Documents Deleted Succesfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS })
    }
    else if(response && response.isDeleted) {
        mdaeNotfy({ message: data[0].documentName + " Deleted Succesfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS })
    }
    return response;

};

const mockData = () => {
    return ([])
};

const mock = () => Promise.resolve(mockData());

register(DELETE_DOCUMENT, service, mock);
